import URI from 'urijs';
import moment from 'moment';
import { isEmpty, isInteger, get } from 'lodash';
import { generateUrlWithParams, formatDateForHashParams } from 'Utils/uri/uriUtils';
import { QUERY_DEPARTURE_DATE, QUERY_DURATION, QUERY_TRANSPORT } from 'Utils/uri/constants';
import { QUERY_QUERY_PARAM, PRODUCTS_TO_COMPARE_QUERY_PARAM } from './constants';

function getCriteriaFromQueryParams(url) {
  return criteria => {
    const facetQueryParams = url ? new URI(url).query(true) : {};
    return get(facetQueryParams, criteria, null);
  };
}

function getUrlWithUnpersistedData(options) {
  const { url, query, productIdsToCompare = [], departureCity, departureDate, duration } = options;

  const queryParams = {
    [PRODUCTS_TO_COMPARE_QUERY_PARAM]: productIdsToCompare,
  };

  if (!isEmpty(query)) {
    queryParams[QUERY_QUERY_PARAM] = query.label;
  }

  if (!isEmpty(departureCity)) {
    queryParams[QUERY_TRANSPORT] = departureCity;
  }

  let departureDateTimestamp = departureDate;
  if (moment.isMoment(departureDate) && departureDate.isValid()) {
    departureDateTimestamp = departureDate.valueOf();
  }
  if (isInteger(departureDateTimestamp)) {
    queryParams[QUERY_DEPARTURE_DATE] = formatDateForHashParams(departureDateTimestamp);
  }

  if (isInteger(duration) && duration > 0) {
    queryParams[QUERY_DURATION] = `${duration}`;
  }

  return generateUrlWithParams(url, { queryParams });
}

export { getCriteriaFromQueryParams, getUrlWithUnpersistedData };
